import script from "./DepartmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentPage.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentPage.vue?vue&type=style&index=0&id=51937937&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51937937"]])

export default __exports__